import { showAlert } from '../common';

app.initializers.add('datitisev/flarum-maintenance', () => showAlert());
